import PipelineStageDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/ci/pipeline_mini_graph/pipeline_stage_dropdown.vue?vue3';
/**
 * Renders the pipeline stages portion of the pipeline mini graph.
 */ export default {
    name: 'PipelineStages',
    components: {
        PipelineStageDropdown
    },
    props: {
        isMergeTrain: {
            type: Boolean,
            required: false,
            default: false
        },
        stages: {
            type: Array,
            required: true
        }
    },
    emits: [
        'job-action-executed',
        'mini-graph-stage-click'
    ]
};
